export default {"src":"/_next/static/media/3user.d46b0a76.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};